<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改接口调用方</span><span v-show="create">新增接口调用方</span></h3>
            </el-col>
        </el-row>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="21">
                        <el-form-item label="调用方ID" prop="appId">
                            <el-input ref="ipt00" v-model="form.appId" placeholder="请输入" maxlength="32" show-word-limit :disabled="!create"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" size="small" @click="getAppId" icon="el-icon-edit" :disabled="!create">生成ID</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="调用方名称" prop="appName">
                        <el-input ref="ipt01" v-model="form.appName" placeholder="请输入" maxlength="100" show-word-limit></el-input>
                    </el-form-item>
                </el-row>
                <!-- <el-row>
                    <el-col>
                        <el-form-item label="开票单位代码" prop="agencyCode">
                            <el-input ref="ipt02" v-model="form.agencyCode" placeholder="请输入" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row> -->

                <el-row>
                        <el-col :span="24">
                            <el-form-item prop="agencyName" label="开票单位名称">
                                <el-input ref="agencyName" v-model="form.agencyName"
                                          maxlength="120"
                                          @focus="() => {
                                            showDiyTree(treeData, form.agencyCode, {title:'开票单位', placeholder: '请输入开票单位名称', treeCallBack: (nodes) => {
                                                let agencyName = ''
                                                if (nodes.length == 0) {
                                                    this.form.agencyCode = ''
                                                } else {
                                                    this.form.agencyCode = nodes[0].id;
                                                    agencyName = nodes[0].label;

                                                    this.form.supProCode = nodes[0].pid;
                                                    this.form.supProName = nodes[0].plabel;
                                                }
                                                this.$set(this.form, 'agencyName', agencyName)
                                                             
                                                this.$refs.agencyName.blur()
                                            }})
                                          }"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                <el-row>
                    <el-col :span="24">
                        <el-form-item label="接口名称" prop="appApiNameArray">
                            <el-select ref="ipt03" v-model="appApiSelectArray" multiple collapse-tags style="" placeholder="请选择">
                                <el-option v-for="item in appApiOptions" :key="item.apiCode" :label="item.apiName" :value="item.apiCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                   <el-col :span="21">
                        <el-form-item label="调用密码" prop="appKey">
                            <el-input ref="ipt04" v-model="form.appKey" placeholder="请输入" maxlength="16" show-word-limit readonly="ture"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" size="small" @click="getAppKey" icon="el-icon-edit">生成密码</el-button>
                    </el-col>
                </el-row>
               
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="有效期起" prop="validityDateBgn" >
                            <el-date-picker v-model="form.validityDateBgn" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"  />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有效期止" prop="validityDateEnd" >
                            <el-date-picker v-model="form.validityDateEnd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"  />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否限制IP" prop="isVerifyIp">
                            <el-select v-model="form.isVerifyIp">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否加密调用" prop="isEncryption">
                            <el-select v-model="form.isEncryption">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="IP地址" prop="ip">
                            <el-input ref="ipt05" v-model="form.ip" placeholder="请输入" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="端口号" prop="port">
                            <el-input ref="ipt06" v-model="form.port" placeholder="请输入" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="加密算法" prop="sign">
                            <el-input ref="ipt07" v-model="form.sign" placeholder="请输入" maxlength="20" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="秘钥" prop="tokenKey">
                            <el-input ref="ipt08" v-model="form.tokenKey" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="调用网络方式" prop="networkMode">
                            <el-select v-model="form.networkMode" placeholder="请选择">
                                <el-option v-for="item in networkModeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="调用网络方式" prop="networkMode">
                            <el-select v-model="form.networkMode">
                                <el-option label="内网" value="01"></el-option>
                                <el-option label="外网" value="02"></el-option>
                            </el-select>
                        </el-form-item> -->
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有效标志" prop="isValid">
                            <el-select v-model="form.isValid">
                                <el-option label="是" value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否接收数据" prop="isReceiveData">
                            <el-select v-model="form.isReceiveData">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="接收数据方式" prop="receiveDataMode">
                            <el-select v-model="form.receiveDataMode" placeholder="请选择">
                                <el-option v-for="item in receiveDataModeOptions" :key="item.value" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="接收数据地址" prop="receiveDataUrl">
                            <el-input ref="ipt09" v-model="form.receiveDataUrl" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <tree ref="myTree" @treeCallBack="treeCallBack($event)"></tree>
    </div>
</template>

<script>
   // import _ from "lodash"
    import tree from "./Tree"

    let _kits, _form, fn
    export default {
        components: {
            tree
        },
        props: ["entity"],
        data() {
            var checkAppId = (rule, value, callback) => {
                const reg = /^[0-9A-Z]*$/;
                if (!reg.test(value)) {
                    callback(new Error("调用方ID只能是数字和大写字母组成"));
                } else {
                    callback();
                }
            };
            var checkValidityDateEnd = (rule, value, callback) => {
                let validityDateBgn = this.form.validityDateBgn;
                if(value < validityDateBgn){
                    callback(new Error("有效期起必须大于等于有效期止"));
                }else{
                    callback();
                }
            };
            var checkIp = (rule, value, callback) => {
                let isVerifyIp = this.form.isVerifyIp;
                if(isVerifyIp=="Y"){
                    if(value!=""){
                        const reg =  /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/;
                        if (!reg.test(value)) {
                            callback(new Error("IP地址格式不正确"));
                        } else {
                            callback();
                        }
                    }else{
                        callback(new Error("请输入IP地址"));
                    }
                }else{
                    if(value!=""){
                        const reg =  /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/;
                        if (!reg.test(value)) {
                            callback(new Error("IP地址格式不正确"));
                        } else {
                            callback();
                        }
                    }else{
                        callback();
                    }
                }
                
            };
            var checkReceiveDataUrl = (rule, value, callback) => {
                let isReceiveData = this.form.isReceiveData;
                if(isReceiveData=="Y"){
                    if(value!=""){
                        callback();
                    }else{
                        callback(new Error("请输入接收数据地址"));
                    }
                }else{
                    callback();
                }
                
            };
            var checkPort = (rule, value, callback) => {
                let isVerifyIp = this.form.isVerifyIp;
                if(isVerifyIp=="Y"){
                    if(value!=""){
                        const reg =  /^\+?[1-9]\d*$/;
                        if (!reg.test(value)) {
                            callback(new Error("端口号只能是数字"));
                        } else {
                            callback();
                        }
                    }else{
                        callback(new Error("请输入端口号"));
                    }
                }else{
                    if(value!=""){
                        const reg =  /^\+?[1-9]\d*$/;
                        if (!reg.test(value)) {
                            callback(new Error("端口号只能是数字"));
                        } else {
                            callback();
                        }
                    }else{
                        callback();
                    }
                   
                }
            };
            var checkSign = (rule, value, callback) => {
                let isEncryption = this.form.isEncryption;
                if(isEncryption=="Y"){
                    if(value!=""){
                        const reg = /^[0-9A-Za-z]*$/;
                        if (!reg.test(value)) {
                            callback(new Error("加密算法只能是数字和字母组成"));
                        } else {
                            callback();
                        }
                    }else{
                        callback(new Error("请输入加密算法"));
                    }
                }else{
                    if(value!=""){
                        const reg = /^[0-9A-Za-z]*$/;
                        if (!reg.test(value)) {
                            callback(new Error("加密算法只能是数字和字母组成"));
                        } else {
                            callback();
                        }
                    }else{
                        callback();
                    }
                }
            };
            var checkTokenKey = (rule, value, callback) => {
                let isEncryption = this.form.isEncryption;
                if(isEncryption=="Y"){
                    if(value!=""){
                        const reg = /^[0-9A-Za-z]*$/;
                        if (!reg.test(value)) {
                            callback(new Error("秘钥只能是数字和字母组成"));
                        } else {
                            callback();
                        }
                    }else{
                        callback(new Error("请输入秘钥"));
                    }
                }else{
                    if(value!=""){
                        const reg = /^[0-9A-Za-z]*$/;
                        if (!reg.test(value)) {
                            callback(new Error("秘钥只能是数字和字母组成"));
                        } else {
                            callback();
                        }
                    }else{
                        callback();
                    }
                }
            };

            let create = !this.entity.appId
            let form
            if (create) {
                form = {
                    appId: "",
                    appName: "",
                    //agencyCode: "",
                    apiName: "",
                    appKey: "",
                    isVerifyIp: "N",
                    ip: "",
                    port: "",
                    networkMode: "01",
                    isEncryption: "N",
                    sign: "",
                    tokenKey: "",
                    validityDateBgn: "",
                    validityDateEnd: "",
                    isValid: "Y",
                    isReceiveData:"Y",
                    appApiNameArray:"",
                    receiveDataUrl: "",
                    receiveDataMode: "01"

                }
            } else {
                form = Object.assign({}, this.entity)
                form.appApiNameArray = "";
                console.log(this.entity)
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                create,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                    appId: [{
                            required: true,
                            message: "请输入调用方ID",
                            trigger: "blur"
                        },{
                            validator: checkAppId,
                            trigger: "blur"
                        },{
                            max: 32,
                            message: "最多32个字符",
                            trigger: "blur"
                        }
                    ],
                    appName: [{
                            required: true,
                            message: "请输入调用方名称",
                            trigger: "blur"
                        }, {
                            max: 100,
                            message: "最多100个字符",
                            trigger: "blur"
                        }
                    ],
                    agencyName: [{
                            required: true,
                            message: "请输入开票单位名称",
                            trigger: "blur"
                        },
                        {
                            max: 30,
                            message: "最多30个字符",
                            trigger: "blur"
                        }
                    ],
                    appApiNameArray: [{
                        required: true,
                        message: "请选择接口名称",
                        trigger: "blur"
                    }],
                    appKey: [{
                            required: true,
                            message: "请生成调用密码",
                            trigger: "blur"
                        },{
                            max: 16,
                            message: "最多16个字符",
                            trigger: "blur"
                        }
                    ],
                    validityDateBgn: [{
                        required: true,
                        message: "请选择有效期起",
                        trigger: "blur"
                    }],
                    validityDateEnd: [{
                        required: true,
                        message: "请选择有效期止",
                        trigger: "blur"
                    },{
                            validator: checkValidityDateEnd,
                            trigger: "blur"
                        }
                    ],
                    ip: [{
                            validator: checkIp,
                            trigger: "blur"
                        },{
                            max: 20,
                            message: "最多20个字符",
                            trigger: "blur"
                        }
                    ],
                    port: [{
                            validator: checkPort,
                            trigger: "blur"
                        },{
                            max: 20,
                            message: "最多20个字符",
                            trigger: "blur"
                        }
                    ],
                    sign: [{
                            validator: checkSign,
                            trigger: "blur"
                        },{
                            max: 20,
                            message: "最多20个字符",
                            trigger: "blur"
                        }
                    ],
                    tokenKey: [{
                            validator: checkTokenKey,
                            trigger: "blur"
                        },{
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                    receiveDataUrl: [{
                            validator: checkReceiveDataUrl,
                            trigger: "blur"
                        },{
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                },
                networkModeOptions: [],
                appApiSelectArray:[],
                appApiNameArray:[],
                appApiOptions: [],
                receiveDataModeOptions: []
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                this.form.appApiNameArray ="";
                for (let i = 0; i < this.appApiSelectArray.length; i++) {
                    if (i == this.appApiSelectArray.length - 1) {
                        this.form.appApiNameArray = this.form.appApiNameArray + this.appApiSelectArray[i];
                    } else {
                        this.form.appApiNameArray = this.form.appApiNameArray + this.appApiSelectArray[i] + ",";
                    }
                }
                _form.submit()
            },
            getAppId() {
                this.form.appId ="";
                var arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                num = "";
                for(var i = 0; i < 32; i++) {
                    num += arr[parseInt(Math.random() * 36)];
                }
                this.form.appId =num;
                _kits.page.foucus("ipt00")
                _kits.page.foucus("ipt01")
                _kits.page.foucus("ipt00")
            },
            getAppKey() {
                this.form.appKey ="";
                var arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
                num = "";
                for(var i = 0; i < 16; i++) {
                    num += arr[parseInt(Math.random() * 36)];
                }
                this.form.appKey =num;
                _kits.page.foucus("ipt04")
                _kits.page.foucus("ipt05")
                _kits.page.foucus("ipt04")
            },
            showDiyTree(arr, id, option) {
                fn = option.treeCallBack
                this.$refs.myTree.showTree(arr, id, option)
            },

            treeCallBack(nodes) {
                if (fn != undefined) {
                    fn(nodes)
                }
            },
            initTreeData(fn_call, fn_filter) {
                _kits.api.call(
                    "AGENCYTREE",
                    {},
                    result => {
                        if (result.returnCode == "0000") {
                            fn_call(_kits.arr2TreeData(result.data, fn_filter))
                        } else {
                            this.$message.error(result.returnMsg)
                        }
                    }
                )
            },
        },
        created() {
            _kits = this.$kits();
            _kits.api.call(
                "QUERYAPPAPILIST", {
                    flag: "1"
                },
                result => {
                    if (result.returnCode == "0000") {
                        this.appApiOptions = result.data.appApiList;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call( 
                "GETCOLLECTION", {
                   "collectionId": "apiappNetworkModeEnumCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        //console.log(result.data);
                        this.networkModeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            _kits.api.call( 
                "GETCOLLECTION", {
                   "collectionId": "notifyDateTypeEnumCollection"
                },
                result => {
                    if (result.returnCode == "0000") {
                        //console.log(result.data);
                        this.receiveDataModeOptions = result.data;
                    } else {
                        this.$message.error(result.returnMsg);
                    }
                }
            );
            if (!this.create) {
                _kits.api.call(
                    "QUERYAPPAPILIST", {
                        flag: "2",
                        appId:this.form.appId
                    },
                    result => {
                        if (result.returnCode == "0000") {
                            let appApiList = new Array(result.data.appApiList.length);
                            for (let i = 0; i < result.data.appApiList.length; i++) {
                                appApiList[i] = result.data.appApiList[i].apiCode;
                            }
                            this.appApiSelectArray = appApiList;
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                );
            }
            this.initTreeData(data => {
                this.treeData = data  
            }, a => {
                //a.disabled =    a.type     // 添加属性
                //a.disabled =    a.type =='1'     // 添加属性
                //return false
            })
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "ADDAPIAPPDETAILS" : "UPDATEAPIAPPDETAILS"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt00")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
            //*/
        }
    }
</script>
